import { render, staticRenderFns } from "./questionbank-list.vue?vue&type=template&id=5190deba&"
import script from "./questionbank-list.vue?vue&type=script&lang=js&"
export * from "./questionbank-list.vue?vue&type=script&lang=js&"
import style0 from "./questionbank-list.vue?vue&type=style&index=0&id=5190deba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports